// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './utils/DateUtil'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Vant from 'vant'
import '@vant/touch-emulator'
import 'vant/lib/index.css'

import EventBus from './utils/EventBus'
import apis from './apis'

import MyComponent from './components'

import 'font-awesome/scss/font-awesome.scss'
import './assets/style.scss'

Vue.use(ElementUI)
Vue.use(Vant)

const eventBus = new EventBus()

Vue.prototype.$eventBus = eventBus

Vue.use(apis, {
  eventBus,
  getToken: () => store.getters['Profile/token']
})

Vue.use(MyComponent)

store.dispatch('Profile/addListener', null).then(() => {})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js